<template>
  <div>

  <data-table
  table-ref="landlordstable"

  title="Landlords"
  icon="fa fa-house"

  url="report/property/landlords"
  :fields="fields"

  sort-field="name"

  search-placeholder="Search Landlords..."
  detail-component="property-landlord-detail"
  />

</div>
</template>

<script>

import Vue from 'vue'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import PropertyLandlordDetail from '@/components/dashboard/property/PropertyLandlordDetail'

Vue.component('property-landlord-detail', PropertyLandlordDetail)

export default {
  mixins: [DateMixins, NumberMixins],

  methods: {
    formatExpiry (value) {
      return this.formatFriendlyDate(value, true)
    }
  },

  data () {
    return {
      stats: this.getStats(),
      landowners: [],
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: 'name',
          title: 'Landlord'
        },
        {
          name: 'sites',
          title: 'Sites'
        },
        {
          name: 'started',
          title: 'Started',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate
        },
        {
          name: 'expiry',
          title: 'Max. Expiry',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          callback: this.formatDate
        },
        {
          name: 'avgAmount',
          title: 'Avg. Rental',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatNumber
        },
        {
          name: 'totalAmount',
          title: 'Total Rental',
          callback: this.formatNumber
        },
        {
          name: 'totalDeposit',
          title: 'Total Deposit',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down',
          callback: this.formatNumber
        }
      ]
    }
  }

}
</script>

<style>
.dash-heading {
  font-size: 3em;
  color: lightgrey;
  padding-top: 0.852em;
  margin-bottom: 0.528em;
  border-bottom: 1px solid lightgrey}
</style>



// WEBPACK FOOTER //
// PropertyLandlords.vue?6a02a9c5